import { render, staticRenderFns } from "./Productstable.vue?vue&type=template&id=10635ce9&scoped=true&"
import script from "./Productstable.vue?vue&type=script&lang=js&"
export * from "./Productstable.vue?vue&type=script&lang=js&"
import style0 from "./Productstable.vue?vue&type=style&index=0&id=10635ce9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10635ce9",
  null
  
)

export default component.exports